export const CSimpleCopyFragments = {
  field: `
    fragment simpleCopy on simpleCopy_MatrixField {
      ... on simpleCopy_block_Entry {
        id
        typeHandle
        idName
        headingSize
        headingColor
        heading
        copy
      }
    }
  `,
  field2: `
    fragment simpleCopy2 on simpleCopy2_MatrixField {
      ... on simpleCopy2_block_Entry {
        id
        typeHandle
        idName
        headingSize
        headingColor
        heading
        copy
      }
    }
  `,
};
